import { Injectable } from '@angular/core';

/**
 * A simple service that keeps a map of string keys to component types.
 * We need this approach if we are sending component types through redux.
 * Redux locks objects that pass through it, so we if we were to send an actual component type
 * it would blow up trying to instantiate it, as angular writes something to the prototype while instantiating the component.
 * So, instead of passing the component type itself, we register any component types we send via redux during instantiation
 * of the project and then retrieve them by string->type mapping when we need to instantiate them.
 *
 * PS - this service is better off in some other project but I tried  putting it in shared-ui-kit and got circular dependency
 * on dialog-module->shared-ui-kit->dialog-module
 *
 * So for now keeping it in dialog module
 */
@Injectable({
  providedIn: 'root'
})
export class DynamicComponentRegistrationService {
  private _stringToComponentMap = new Map<string, any>();
  // Todo: register/unregister component logic should be moved to a separate service
  // as this is now used by more than just modal dialog service
  registerComponent(key: string, component: any) {
    this._stringToComponentMap.set(key, component);
  }
  getRegisteredComponent(key: string): any {
    return this._stringToComponentMap.get(key);
  }
}
